export enum TOGGLEID {
}

export enum TOGGLENAME {
  SUBSCRIBEBYEMAIL = "SubscribeByEmail",  
  AUTHLIBASMCUTOVER = "AuthLib_AsmCutover",
  DATEDIFFCALCULATION = "DateDiffCalculation",
  NAVEXENGAGEREPORTS = "NavexEngageReports",
  HEADERCROSSSELL = "HeaderCrossSell",
  SUBSCRIBEBYEMAILDM = "SubscribeByEmailDM",
  BENCHMARKINGCOMPONENT = "BenchmarkingComponent"
}